import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import {
  getCountryFlagByCode,
  getCountryNameByCode,
} from "shared/services/countries"

import styles from "../flags.module.css"

function CountryFlag({ code, size, className }) {
  const { t: translate } = useTranslate()
  const name =
    code === "EM" ? translate("Ebay Motors") : getCountryNameByCode(code)
  const flag = getCountryFlagByCode(code)
  return flag && name ? (
    <img
      className={[
        className,
        styles.flag,
        styles[`size${size}`] || styles.size24,
        "v-m",
      ].join(" ")}
      src={flag}
      alt={name}
      data-tip={translate(name)}
      data-effect="solid"
    />
  ) : null
}

CountryFlag.propTypes = {
  code: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
}

CountryFlag.defaultProps = {
  size: 24,
  className: "",
}

export default CountryFlag
